// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: 'AIzaSyBlqZ1ac9pR-CrMVNGHlfOt9L-fjo52WQk',
    authDomain: 'enqpoint.firebaseapp.com',
    projectId: 'enqpoint',
    storageBucket: 'enqpoint.appspot.com',
    messagingSenderId: '233100012857',
    appId: '1:233100012857:web:f30342750d9d0e7a258ce8',
    measurementId: 'G-VWEKNJQDVW',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
